<template>
  <v-container class="input-text-size">
    <v-row dense>
      <v-col cols="4">
        <ClarionDateControl class="input-text-size"
                        :isRequired="false"
                        :isIsoDate="true"
                        :isToggle="false"
                        label="From Date"
                        v-model="editedItem.fromDate"
                        :isDisabled="isReadOnly"
                        />
                      </v-col>
      <v-col cols="4">
        <ClarionDateControl class="input-text-size"
                        :isRequired="false"
                        :isIsoDate="true"
                        :isToggle="false"
                        label="To Date"
                        v-model="editedItem.toDate"
                        :isDisabled="isReadOnly"
                        />
                       </v-col>
      <v-col cols="4" class="mt-4">
        <v-text-field
        label="Section/Page"
        dense hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.section"
        :readonly="isReadOnly">
      </v-text-field>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="6">
        <v-text-field label="Source #"
        dense
        hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.sourceNo"
        :readonly="isReadOnly"
        @blur="preUpdateEditedItem(editedItem)">
      </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6">
        <v-text-field
        label="Source Description"
        dense hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.sourceDesc"
        :readonly="isReadOnly">
      </v-text-field>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6">
        <v-text-field
        label="Fund #"
        dense hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.fundNo"
        :readonly="isReadOnly"
        @blur="preUpdateEditedItem(editedItem)">
      </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6">
        <v-text-field
        label="Fund Description"
        dense
        hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.fundDesc"
        :readonly="isReadOnly">
      </v-text-field>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="6">
        <v-text-field
        label="Unit Code"
        dense hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.unit"
        :readonly="isReadOnly">
      </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6">
        <v-text-field
        label="Unit Fund"
        dense hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.fund"
        :readonly="isReadOnly">
      </v-text-field>
      </v-col>
    </v-row>
    <!-- <v-row dense>
      <v-col cols="8">
        <v-text-field label="Unit Code/Fund Description" dense hide-details></v-text-field>
      </v-col>
    </v-row> -->

    <v-row dense>
      <v-col cols="6">
        <v-text-field
        label="Remit Unit"
        dense hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.remitUnit"
        :readonly="isReadOnly">
      </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6">
        <v-text-field
        label="Remit Warrant Number"
        dense
        hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.remitWarrantNumber"
        :readonly="isReadOnly">
      </v-text-field>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="6">
        <v-text-field
        label="Money From"
        dense hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.moneyFrom"
        :readonly="isReadOnly">
      </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6">
        <v-text-field
        label="Created From"
        dense hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.createdFrom"
        :readonly="isReadOnly">
      </v-text-field>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="6">
        <v-text-field
        label="Miscellaneous Receipt #"
        dense hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.miscReceiptNo"
        :readonly="isReadOnly">
      </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6">
        <v-text-field
        label="Misc Date"
        dense
        hide-detail
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.miscDate"
        :readonly="isReadOnly"
      >
    </v-text-field>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="4">
        <v-text-field
        label="Amount"
        dense hide-details
        v-model="editedItem.amount"
        :readonly="isReadOnly"
        @focus="amountToNum('amount'); $event.target.select()"
        @blur="roundAmount('amount')"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-btn outlined color="primary" small
        :disabled="isNegativeAmountButtonDisabled"
        @click="negativeAmountToResale">Move Negative Amount to Resale</v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="2">
        <v-text-field
         dense hide-details
         label="Resale Amount"
        v-model="editedItem.resaleAmount"
        :readonly="isReadOnly"
        @focus="amountToNum('resaleAmount'); $event.target.select()"
        @blur="roundAmount('resaleAmount')" >
      </v-text-field>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-text-field
        label="Comment"
        dense
        hide-details
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.comment"
        :readonly="isReadOnly">
      </v-text-field>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="3">
        <v-checkbox
          label="Special Apportionment"
          dense
          :readonly="isReadOnly"
          v-model="editedItem.isSpecialApportionment"
        >
        </v-checkbox>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-checkbox label="Locked" dense v-model="editedItem.isLocked"></v-checkbox>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mapActions,
  mapGetters, mapMutations, mapState,
} from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import '../../../assets/style.css';
// import { amountFields } from './apportionmnetUtils';
import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import { toFiscalYear, toIsoDate } from '../../../util/shared/tmc-global';

const fundCrudKey = 'sharedFund';

export default {
  mixins: [GlobalToCaps],
  data() {
    return {
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  created() {
    this.loadLists();
  },
  components: {
    ClarionDateControl,
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items']),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),

    editedItem: {
      get() {
        const item = this.item(this.baseCrudKey);
        // amountFields.forEach((f) => {
        //   item[f] = amountFormat(amountToNumber(item[f]));
        // });
        return item;
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    funds() {
      const fundObjs = this.items(fundCrudKey) || [];
      return fundObjs;
    },
    sources() {
      const sourceObjs = this.items('sharedSource') || [];
      return sourceObjs;
    },
    isReadOnly() {
      return this.editedItem.isLocked;
    },
    isNegativeAmountButtonDisabled() {
      const amount = amountToNumber(this.editedItem.amount);
      return amount < 0 && this.editedItem.fundNo === '1220';
    },
  },
  methods: {
    ...mapActions('shared/fund', ['loadFunds']),
    ...mapActions('shared/source', [
      'loadCmnSource',
    ]),
    ...mapActions('apportionment/apportionmentTab', [
      'upsertResaleTransaction',
      'upsertApportionmentTransaction',
    ]),
    ...mapActions(['flashError']),
    ...mapMutations('base/crud', ['setItem']),
    async negativeAmountToResale() {
      const item = this.item(this.baseCrudKey);
      const checkForNegativeAmount = Math.sign(amountToNumber(item.amount));
      if (checkForNegativeAmount === -1) {
        const comment = `Negative apportionment amount of ${item.amount} was moved to Resale fund `;
        const obj = {
          ...item,
          toDate: toIsoDate(item.toDate),
          fromDate: toIsoDate(item.fromDate),
          amount: 0,
          isNegativeAmount: false,
          resaleAmount: amountToNumber(item.amount),
          comment,
        };
        const savedItem = await this.upsertApportionmentTransaction(
          { item: obj, baseCrudKey: this.baseCrudKey },
        );
        if (!savedItem || !savedItem._id) {
          this.flashError('There was a problem moving the negative amount to Resale. Please try again.');
          return;
        }
        this.setItem([this.baseCrudKey, savedItem]);
        await this.upsertResaleTransaction({ item: savedItem, baseCrudKey: this.baseCrudKey });
      }
    },
    loadLists() {
      const fy = toFiscalYear(new Date());

      this.loadFunds({
        criteria: {
          fiscalYear: fy || 0,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: fundCrudKey,
      });
      this.loadCmnSource({
        criteria: {
          fiscalYear: fy || 0,
          isSkipMiscellaneousTransaction: false,
          sortBy: [
            {
              column: 'sourceSubSourceNumber',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: 'sharedSource',
      });
    },
    async preUpdateEditedItem(item) {
      const selectedFund = this.funds.find((f) => f.fund === item.fundNo);
      const selectedSource = this.sources.find((s) => s.sourceSubSourceNumber === item.sourceNo);
      let updatedItem = { ...item };
      if (selectedFund) {
        updatedItem = {
          ...item,
          fundDesc: selectedFund.description || '',
        };
      }
      if (selectedSource) {
        updatedItem = {
          ...updatedItem,
          sourceDesc: selectedSource.sourceDescription || '',
        };
      }
      this.setItem([this.baseCrudKey, updatedItem]);
    },
    roundAmount(field) {
      const updatedItem = { ...this.editedItem };
      updatedItem[field] = amountFormat(amountToNumber(this.editedItem[field]));
      this.editedItem = updatedItem;
    },
    amountToNum(f) {
      const updatedItem = { ...this.editedItem };
      updatedItem[f] = amountToNumber(this.editedItem[f]);
      this.editedItem = updatedItem;
    },
  },
};
</script>

<style scoped>

</style>
